import { useState } from "react";

import useUpdateCurrentGroupListener from "./useUpdateCurrentGroupListener";
import useGroupsTreeData from "./useGroupsTreeData";

const useGroupsNavigationData = ({
  workspace,
  featureFlags,
  isSelected,
  eventEmitter,
}) => {
  const [hierarchyIds, setHierarchyIds] = useState(null);
  const {
    root,
    treeData,
    rootGroupsLoading,
    groupTypes,
    refreshTree,
    sortOption,
  } = useGroupsTreeData({
    workspace,
    featureFlags,
    isSelected,
  });

  // Listen to current group change and set hierarchyIds
  useUpdateCurrentGroupListener(
    root,
    setHierarchyIds,
    refreshTree,
    eventEmitter
  );

  return {
    root,
    treeData,
    rootGroupsLoading,
    groupTypes,
    hierarchyIds,
    setHierarchyIds,
    sortOption,
  };
};

export default useGroupsNavigationData;
